import axios from "axios";

export default function getNotifierLogs() {
    return axios.get("https://admin-notifier.hirist.com/notify/logs")
}